import React from 'react';
import { GridRow } from '@mui/x-data-grid';
import { usePerson } from 'talent_matching/hooks/use_people';

// Injects the latest person from the query cache to keep
// row data in sync with the side panel.
const SyncedRow = (props: React.ComponentProps<typeof GridRow>) => {
  const { person } = usePerson(props.row.id);

  return <GridRow {...props} row={person} />;
};

export default SyncedRow;
